import React from 'react';

export const OuterElementContext = React.createContext({});

export const OuterElementType = React.forwardRef<HTMLDivElement>((props, ref) => {
  const { component, ...outerProps } = React.useContext(OuterElementContext) as Record<string, unknown>;
  return <div className="outer-element" ref={ref} {...props} {...outerProps} />;
});
